module.exports = __webpack_public_path__ + "img/4-en.a61133c8.png";